import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
  ElementRef,
  ViewChild,
  QueryList,
  ViewChildren,
  Input,
  ChangeDetectorRef,
  Pipe,
  PipeTransform
} from '@angular/core';
import { IChat } from '@common/models/Chat/IChat';
import { Subject, Subscription, debounceTime, distinctUntilChanged, firstValueFrom } from 'rxjs';
import { ChatServices } from '@app/services/chat.service';
import { MessageService } from 'primeng/api';
import { IChatInteraction } from '@common/models/Chat/IChatInteraction';
import { ChatType } from '@common/enums/ChatType';
import { ChatState } from '@common/enums/ChatState';
import { CurrentUserStateService } from '@app/services/currentUserState.service';
import cloneDeep from 'lodash/cloneDeep';
import { DOMAIN_SPECIFIC_CHAT_TYPES } from '@common/constants';
import { ActivatedRoute } from '@angular/router';
import { CHAT_TYPE_ROUTE_MAP } from '@app/constants';


@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  transform(value: string, searchText: string): string {
    if (!searchText) return value;
    const regex = new RegExp(searchText, 'gi');
    return value.replace(regex, (match) => `<b>${match}</b>`);
  }
}

@Component({
  selector: 'app-chat-sidebar',
  templateUrl: './chat-sidebar.component.html',
  styleUrls: ['./chat-sidebar.component.scss'],
})
export class ChatSidebarComponent implements OnInit, OnDestroy {
  @Output() searchClicked = new EventEmitter<void>();

  /** controls custom tooltip for search button */
  showSearchTooltip = false;

  searchDialogVisible = false;
  // bound to the input inside the dialog
  searchText = '';

  /** Opens the search modal */
  onSearchClick(): void {
    this.searchDialogVisible = true;
  }

  /** Closes the search modal (fired by (onHide)) */
  closeSearchDialog(): void {
    this.searchDialogVisible = false;
  }

  activeChat: IChat;
  showrecentChats: boolean = true;
  selectedChat: string;
  getAllChatsSub: Subscription = new Subscription();
  getSearchChatsSub!: Subscription;
  getSearchChatInteractionSub!: Subscription;
  getChatDetailsSub: Subscription = new Subscription();
  deleteChatSub: Subscription = new Subscription();
  getUserSub: Subscription = new Subscription();
  createChatSub: Subscription;
  updateChatTypeSub: Subscription;
  currentChatPeriod: string = 'Today';
  chatPeriod: string = 'Today';
  monthReducer: number = 1;

  get allChats() {
    return this.chatServices.getAllChatsValue();
  }

  set allChats(value) {
    this.chatServices.updateAllChats(value);
  }

  // Helper method to update allChats and notify service after nested modifications
  private syncAllChatsToService(): void {
    this.chatServices.updateAllChats([...this.allChats]);
  }

  isloading: boolean = true;
  showTooltip: boolean = false;
  dialogMessage: string;
  displayConfirmationDialog: boolean = false;
  deletingChat: IChat;
  deletingChatIndex: number;
  displayDialogType: string;
  deleteingChatPeriod: string;
  periodIndex: number;
  updatedChatName:string;
  searchResults: any[] | 'No Results' = [];
  searchQuery: string;
  searchLoading: boolean = false;
  searchTextUpdate = new Subject<any>();
  isEndChatList:boolean = false;
  isEndSearchResults: boolean = false;
  lastUpdatedAt: string | undefined;
  lastChatId: string | undefined;
  @ViewChildren('itemElement') itemElements: QueryList<ElementRef>;
  scrollUpdate = new Subject<any>();
  ESGChatType= ChatType.ESG
  codeInterpreterChatType = ChatType.codeInterpreter
  agenticWorkflowChatType = ChatType.agenticWorkflow
  bookmarkChatType = ChatType.bookmarkchat
  hrDocumentsChatType = ChatType.HRDocuments
  QECChatType = ChatType.QEC
  deepResearchChatType = ChatType.deepResearch
  VanillaChatType = ChatType.Normal
  DocumentChatType = ChatType.UnstructuredDocument
  StructuredDocChatType = ChatType.StructuredDocument
  private readonly qiqOption = {
    label: 'QIQ Chat',
    command: (event) => this.updateNewChat(event),
    icon: 'customQIQ-icon'
  };
  private readonly esgOption = {
    label: 'ESG',
    icon: 'bi bi-recycle',
    command: (event) => this.updateESGChat(event),
  };
  private readonly wfdoOption = {
    label: 'WFDO',
    icon: 'bi bi-database',
    command: (event) => this.updateQECChat(event),
  };

  private readonly chatTypeTochatLabelMap: Partial<Record<ChatType, string>> = {
    [ChatType.Normal]: 'QIQ Chat',
    [ChatType.QEC]: 'WFDO',
    [ChatType.ESG]: 'ESG',
  }
  isBookmarked:boolean = false;
  displayCustomInstructions: boolean = false;
  customInstructions: string = '';
  isDropdownOpen: boolean = false;
  splitButtonItems = [this.qiqOption, this.esgOption];
  selectedsplitButtonItems: any;
  selectedChatType: string = 'QIQ Chat';
  @Input() isCollapsed: boolean = false;
  @Output() toggleSidebar: EventEmitter<void> = new EventEmitter<void>();
  showUsageStats:boolean=false;
  userStateSub: Subscription;

  private readonly scrollSubject = new Subject<Event>();
  public isFetchingResults = false;
  public isLoadingOlderChats: boolean = false;

  @ViewChild('whitespaceDetector') whitespaceDetector!: ElementRef;

  private createdAt: number;

  constructor(
      public readonly chatServices: ChatServices,
      private readonly messageService: MessageService,
      private readonly currentUserState:CurrentUserStateService,
      private readonly cdr: ChangeDetectorRef,
      private readonly route: ActivatedRoute,
      
  ) {
    this.scrollUpdate
    .pipe(debounceTime(500), distinctUntilChanged())
    .subscribe((value) => {
        this.scrollLazyLoad(value);
    });
  }

  checkRBAC() {
    this.userStateSub = this.currentUserState.value$.subscribe(user => {
      if (user && this.currentUserState.isInternalRole()) {
        console.log("user:", user)
        this.splitButtonItems = [
          this.qiqOption,
          this.wfdoOption,
          this.esgOption,
        ];
        this.selectedsplitButtonItems = cloneDeep(this.splitButtonItems).filter(
          item => item.label !== this.selectedChatType
        );
        this.cdr.detectChanges();
      }
      if (user?.createdAt) {
        this.createdAt = new Date(user.createdAt).getTime();
      }
    });
  }

  InitialLoad()
  {
  const now = new Date();
  let initialLoad = [
        {
          period: 'Bookmarks',
          name: 'Bookmarks',
          startDate: new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        ).getTime(),
        endDate: new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + 1
        ).getTime(),
          showChats: true,
          chats: [],
          isBookmarks: true
      },
          {
              period: 'Today',
              name: 'Today',
              startDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate()
              ).getTime(),
              endDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() + 1
              ).getTime(),
              showChats: true,
              chats: [],
          },
          {
              period: 'Yesterday',
              name: 'Yesterday',
              startDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() - 1
              ).getTime(),
              endDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate()
              ).getTime(),
              showChats: true,
              chats: [],
          },
          {
              period: 'Previous 7 Days',
              name: 'Previous 7 Days',
              startDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() - 7
              ).getTime(),
              endDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() - 1
              ).getTime(),
              showChats: true,
              chats: [],
          },
          {
              period: 'Previous 30 Days',
              name: 'Previous 30 Days',
              startDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() - 30
              ).getTime(),
              endDate: new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() - 7
              ).getTime(),
              showChats: true,
              chats: [],
          },
      ];
      return initialLoad
    }

  ngOnInit(): void {
      void this.initializeComponent();
  }

  private async initializeComponent(): Promise<void> {
      // Try to get params from current route, or traverse to find chat route params
      let chatType: string | null = null;
      
      try {
        const paramMap = await firstValueFrom(this.route.paramMap);
        chatType = paramMap.get('type');
        
        // If type is not in current route, try to get it from root's first child (for mobile popup menu case)
        if (!chatType) {
          let currentRoute = this.route.root;
          while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
            const childParamMap = await firstValueFrom(currentRoute.paramMap);
            const typeParam = childParamMap.get('type');
            if (typeParam) {
              chatType = typeParam;
              break;
            }
          }
        }
      } catch (error) {
        console.warn('Error getting route params:', error);
      }
      
      const parsedChatType = CHAT_TYPE_ROUTE_MAP[chatType] ?? ChatType.Normal;
      const newChatLabel = this.chatTypeTochatLabelMap[parsedChatType as ChatType] ?? 'QIQ Chat';
      this.selectedChatType = newChatLabel;
      
      this.chatServices.updateChatTypeStatus(parsedChatType);


      this.searchTextUpdate.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(() => {
        this.fetchSearchResults();
      });

      this.scrollSubject.pipe(debounceTime(300)).subscribe((event) => {
        this.handleScroll(event);
      });

      this.checkRBAC()
      this.selectedsplitButtonItems = cloneDeep(this.splitButtonItems).filter(item => item.label !== this.selectedChatType);
      this.activeChat = this.chatServices.getActiveChat();

      // Subscribe to createChat events from chat-main
      this.createChatSub = this.chatServices.getCreateChatObs().subscribe((chat) => {
          this.getChatsList(chat);
      });

      // Subscribe to updateChatType events from chat-main
      this.updateChatTypeSub = this.chatServices.getUpdateChatTypeObs().subscribe((chatType) => {
          this.updateChatTypeFromChatMain(chatType);
      });
      this.chatServices.getActiveChatObs().subscribe((res: IChat) => {
          if (res) {
              if (this.activeChat == undefined) {
                  this.getChatsList(res);
              }else if((this.activeChat.ESGTableTags !== res.ESGTableTags) && res.ESGTableTags.length>0){
                this.allChats.forEach((chats:any,index:number)=>{
                  chats.chats.forEach((e:IChat,idx:number)=>{
                    if(e.chatId === res.chatId){
                      this.allChats[index].chats[idx] = res;
                    }
                  })
                })
                this.syncAllChatsToService();
              }
              this.activeChat = res;
          }
      });
      this.allChats = this.InitialLoad();
      this.getChatsListInit().then(() => {
        this.checkAndLoadOlderChats();
      });
      window.addEventListener('resize', this.checkAndLoadOlderChats.bind(this));
  }

  updateCurrentChatPeriod(index: number): void {
      this.allChats[index].showChats = !this.allChats[index].showChats;
      this.syncAllChatsToService();
      this.checkAndLoadOlderChats();
  }

  updateESGChat(event:any){
    this.monthReducer = 1;
    if(this.chatServices.chatType !== ChatType.ESG){
      this.allChats = this.InitialLoad();
      this.updatesplitButtonItems(event.item)
      this.isloading = true;
      this.updateChatType(this.ESGChatType);
      this.getChatsListInit();
      this.checkAndLoadOlderChats();
    }
    this.newChat();
  }

  updateCodeInterpreterChat(event:any){
    if(this.getChatType() !== ChatType.codeInterpreter){
      this.updatesplitButtonItems(event.item)
      this.isloading = true;
      this.updateChatType(ChatType.codeInterpreter);
      this.getChatsListInit();
    }
    this.newChat()
  }

  updateagenticWorkflow(event:any){
    if(this.getChatType() !== ChatType.agenticWorkflow){
      this.updatesplitButtonItems(event.item)
      this.isloading = true;
      this.updateChatType(ChatType.agenticWorkflow);
      this.getChatsListInit();
    }
    this.newChat()
  }

  updatebookmarkChatType(event:any){
    if(this.getChatType() !== ChatType.bookmarkchat){
      this.updatesplitButtonItems(event.item)
      this.isloading = true;
      this.updateChatType(ChatType.bookmarkchat);
      this.getChatsListInit();
    }
    this.newChat()
  }

  updateHRDocsChat(event:any){
    if(this.getChatType() !== ChatType.HRDocuments){
      this.updatesplitButtonItems(event.item)
      this.isloading = true;
      this.updateChatType(ChatType.HRDocuments);
      this.getChatsListInit();
    }
    this.newChat()

  }

  updateQECChat(event:any){
    this.monthReducer = 1;
    if(this.getChatType() !== ChatType.QEC){
      this.allChats = this.InitialLoad();
      this.updatesplitButtonItems(event.item)
      this.isloading = true;
      this.updateChatType(ChatType.QEC);
      this.getChatsListInit();
      this.checkAndLoadOlderChats()
    }
    this.newChat();

  }

  updateNewChat(event:any){
    this.monthReducer = 1;
    this.allChats = this.InitialLoad();
    this.updatesplitButtonItems(event.item)
    this.updateChatType(this.VanillaChatType);
    this.newChat();
    this.isloading = true;
    this.getChatsListInit();
  }

  async getChatsListInit(chatPeriod?: string) {
    this.cancelAllChatsSubscriptions();
    this.getAllChatsSub = new Subscription();
    
    const periodsToLoad = this.allChats
      .map((period, index) => ({ period, index }))
      .filter(({ period }) => !chatPeriod || period.period === chatPeriod);

    const chatPromises = periodsToLoad.map(({ index, period }) =>
      this.loadChatPeriodData(index, period)
    );

    await Promise.all(chatPromises);
    this.isloading = false;
    this.checkChatsLength();
  }

  private loadChatPeriodData(index: number, chatPeriodItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.allChats[index].chats = [];
      this.syncAllChatsToService();
      this.getAllChatsSub.add(
        this.chatServices
          .getAllChats(
            chatPeriodItem.startDate,
            chatPeriodItem.endDate,
            chatPeriodItem.isBookmarks || false
          )
          .subscribe({
            next: (response: IChat[]) =>
              this.handleChatPeriodSuccess(index, chatPeriodItem, response, resolve),
            error: (error) =>
              this.handleChatPeriodError(error, reject),
          })
      );
    });
  }

  private handleChatPeriodSuccess(
    index: number,
    chatPeriodItem: any,
    response: IChat[],
    resolve: () => void
  ): void {
    this.isloading = false;
    this.allChats[index].chats = response;
    this.allChats[index].showChats = true;
    this.syncAllChatsToService();

    if (this.currentChatPeriod !== chatPeriodItem.period) {
      resolve();
      return;
    }

    response.forEach((chat: IChat) => {
      if (this.activeChat?.chatId === chat.chatId && this.activeChat !== chat) {
        this.chatServices.updateActiveChatObs(chat);
        this.chatServices.updateActiveChat(chat);
      }
    });

    resolve();
  }

  private handleChatPeriodError(
    error: any,
    reject: (reason?: any) => void
  ): void {
    this.messageService.clear();
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: error.error.message,
    });
    this.isloading = false;
    reject(error);
  }

  async checkChatsLength() {
    let allChatsLength = 0;

    for (const chatPeriodItem of this.allChats) {
      allChatsLength += chatPeriodItem.chats.length;
      await new Promise(resolve => setTimeout(resolve, 0));
    }
    if (allChatsLength < 18 && this.monthReducer < 7) {
      this.loadnewchats();
    }
  }

  ngOnDestroy() {
      this.getAllChatsSub?.unsubscribe();
      this.deleteChatSub?.unsubscribe();
      this.getSearchChatsSub?.unsubscribe();
      this.getSearchChatInteractionSub?.unsubscribe();
      this.userStateSub?.unsubscribe();
      this.getChatDetailsSub?.unsubscribe();
      this.createChatSub?.unsubscribe();
      this.updateChatTypeSub?.unsubscribe();
      window.removeEventListener('resize', this.checkAndLoadOlderChats.bind(this));
  }

  newChat() {
      this.selectedChat = null;
      this.activeChat = undefined;
      this.chatServices.chatConfig = {}
      this.chatServices.updateActiveChatObs(this.activeChat);
      this.chatServices.updateActiveChat(this.activeChat);
      this.updateChat(this.activeChat, 'newsession');
  }

  updateChatType(chatType:ChatType): void {
    this.chatServices.updateChatTypeStatus(chatType);
    this.searchText = '';
    this.searchResults = [];
    this.isEndSearchResults = false;
    this.lastUpdatedAt = undefined;
    this.lastChatId = undefined;
    this.searchLoading = false;
    this.searchTextUpdate.next(this.searchText);
    // Collapse sidebar on mobile after switching chat type
    // if (window.innerWidth <= 576 && !this.isCollapsed) {
    //   this.toggleSidebar.emit();
    // }
  }

  getChatType():ChatType{
    return this.chatServices.getChatType()
  }

  emitToggle(): void {
    this.toggleSidebar.emit();
  }

  async getChatsList(event?): Promise<void> {
    return new Promise((resolve, reject) => {
      // Will get chat ID when we creat a new chat in Chat Main component on Intial Load
      let getListForChatUpdates=true;
      if (event) {
          this.activeChat = event;
          this.selectedChat = event.chatId;
          this.chatPeriod = 'Today';
          if (this.currentChatPeriod === this.chatPeriod) {
            this.allChats.forEach((e,i:number)=>{
                  if(this.currentChatPeriod===e.period && e.chats[0]?.chatId==this.activeChat?.chatId){
                      getListForChatUpdates=false
                  }
              })
            }else{
            this.updateoldchatLIst();
          }
      }
      let startDate: number;
      let endDate: number;
      let isBookmarks:boolean =false
      const chatPeriodToGetChatList = this.chatPeriod;
      this.allChats.forEach((e) => {
          if (e.period == chatPeriodToGetChatList) {
              startDate = e.startDate;
              endDate = e.endDate;
              if(e.isBookmarks){
                isBookmarks=true
              }
          }
      });
      if (getListForChatUpdates) {
        this.getAllChatsSub.add(this.chatServices
          .getAllChats(startDate, endDate, isBookmarks)
          .subscribe({
            next: (response: IChat[]) => {
              if (response?.length == 0) {
                this.isEndChatList = true
              }
              if (this.activeChat?.chatId) {
                const foundItem: IChat = response.find(
                  (chats) => chats.chatId === this.activeChat.chatId
                );
                if (foundItem) {
                  this.activeChat = foundItem;
                  this.chatServices.updateActiveChatObs(foundItem);
                }
              }
              // const tempChat:IChat[]=response.map((i)=>({...i,chatId:i._id}))
              let temp_chatsList: IChat[] = response;
              let chatsList: IChat[] = temp_chatsList;
              let chatsAvailableBool = false;
              this.allChats.forEach((e) => {
                if (e.period == chatPeriodToGetChatList) {
                  chatsAvailableBool = true;
                  e.chats = chatsList;
                  e.showChats = true;
                }
              });
              if (!chatsAvailableBool) {
                this.allChats.push({
                  period: chatPeriodToGetChatList,
                  chats: chatsList,
                  showChats: true,
                  startDate: startDate,
                  endDate: endDate,
                  name: this.allChats?.at(-1).name,
                });
              }
              this.syncAllChatsToService();
              this.checkChatsLength()
              setTimeout(() => resolve(), 0);
            },
            error: (error) => {
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.error.message,
              });
              reject(error);
            },
          }));
      }
    })
  }

  get currentChatType() {
    return this.chatServices.chatType;
  }

  updateoldchatLIst() {
      let startDate: number;
      let endDate: number;
      let isBookmarks:boolean =false
      this.allChats.forEach((e) => {
          if (e.period == this.currentChatPeriod) {
              startDate = e.startDate;
              endDate = e.endDate;
              if(e.isBookmarks){
                isBookmarks=true
              }
          }
      });
      this.getAllChatsSub.add( this.chatServices
          .getAllChats(startDate, endDate, isBookmarks)
          .subscribe({
              next: (response: IChat[]) => {
                  let chatsList: IChat[] = response;
                  let chatsAvailableBool = false;

                  this.allChats.forEach((e) => {
                      if (e.period == this.currentChatPeriod) {
                          chatsAvailableBool = true;
                          e.chats = chatsList;
                          e.showChats = true;
                      }
                  });
                  if (!chatsAvailableBool) {
                      this.allChats.push({
                          period: this.currentChatPeriod,
                          chats: chatsList,
                          showChats: true,
                          startDate: startDate,
                          endDate: endDate,
                          name: this.allChats?.at(-1)?.name,
                      });
                  }
                  this.syncAllChatsToService();
              },
              error: (error) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
              },
          }));
  }

  cancelAllChatsSubscriptions() {
    this.getAllChatsSub.unsubscribe();
  }


  deleteConfirmationDialog(
      element: IChat,
      i: number,
      period: string,
      idx: number
  ) {
      this.displayDialogType = 'delete';
      this.dialogMessage = `Are you sure you want to delete Chat ?`;
      this.displayConfirmationDialog = true;
      this.deletingChat = element;
      this.deletingChatIndex = i;
      this.deleteingChatPeriod = period;
      this.periodIndex = idx;
  }

  ondialogaccept() {
      this.displayConfirmationDialog = false;
      if (this.displayDialogType === 'delete') {
          this.deleteChat(this.deletingChat, this.deleteingChatPeriod);
      }
  }

  onOverlayAction(event: Event, overlay: any, action: string, option: any, period?: string, chatIndex?: number, periodIndex?: number): void {
    event.stopPropagation();
    event.preventDefault();
    
    switch(action) {
      case 'rename':
        overlay.hide();
        setTimeout(() => {
          option.editName = true;
        }, 0);
        break;
      case 'bookmark':
        // Find and update the actual chat object in allChats array
        this.allChats.forEach(chatGroup => {
          const chat = chatGroup.chats.find(c => c.chatId === option.chatId);
          if (chat) {
            chat['actionLoader'] = true;
          }
        });
        overlay.hide();
        this.currentChatPeriod = period;
        this.bookmarkchat(option.chatId, option.isBookmarked, period);
        break;
      case 'delete':
        // Find and update the actual chat object in allChats array
        this.allChats.forEach(chatGroup => {
          const chat = chatGroup.chats.find(c => c.chatId === option.chatId);
          if (chat) {
            chat['actionLoader'] = true;
          }
        });
        overlay.hide();
        this.deleteConfirmationDialog(option, chatIndex, period, periodIndex);
        break;
    }
  }

  bookmarkchat(chatId:string, isBookmarked:boolean, period:string){

    this.chatServices.editChatDetails(chatId,{isBookmarked : !isBookmarked}, true).subscribe({
      next: (res)=>{
        this.messageService.clear();
        this.messageService.add({
            severity: 'success',
            summary: 'Bookmarked',
            detail: 'Chat added to bookmarks Successfully',
        });

        this.getChatsListInit('Bookmarks')
        this.refreshChatPeriod(res);
        
        // Clear the action loader
        this.allChats.forEach(chatGroup => {
          const chat = chatGroup.chats.find(c => c.chatId === chatId);
          if (chat) {
            chat['actionLoader'] = false;
          }
        });
        this.syncAllChatsToService();
      },
      error: (error) => {
        // Clear the action loader on error
        this.allChats.forEach(chatGroup => {
          const chat = chatGroup.chats.find(c => c.chatId === chatId);
          if (chat) {
            chat['actionLoader'] = false;
          }
        });
        this.syncAllChatsToService();
        
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message || 'Failed to update bookmark',
        });
      }
    });
  }

  onCancelDialog() {
      this.displayConfirmationDialog = false;
      if (this.displayDialogType == 'delete') {
          const chat = this.allChats[this.periodIndex]?.chats[this.deletingChatIndex];
          if (chat) {
              chat['actionLoader'] = false;
          }
          this.syncAllChatsToService();
      }
  }

  deleteChat(chat: IChat, period: string) {
      this.deleteChatSub.add(
          this.chatServices.deleteChat(chat.chatId).subscribe({
              next: (response) => {
                  this.chatPeriod = period;
                  if (this.activeChat?.chatId == chat.chatId) {
                      this.activeChat = undefined;
                      this.chatServices.updateActiveChat(this.activeChat);
                      this.chatServices.updateActiveChatObs(this.activeChat);

                      this.chatServices.emitChatSelected({
                          type: 'deleteChat',
                          activeChat: undefined,
                          chatId: undefined,
                          period: this.currentChatPeriod,
                      });

                      // If we are deleting a non domain specific chat types (DS Playground, DeepResearch, etc..)
                      // then, we will swtich to new Vanilla chat.
                      if(!DOMAIN_SPECIFIC_CHAT_TYPES.includes(this.currentChatType)) {
                        this.chatServices.updateChatTypeStatus(ChatType.Normal);
                      }
                  }
                  this.getChatsList();
                  
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'success',
                      summary: 'Deleted',
                      detail: 'Chat deleted Successfully',
                  });
              },
              error: (error) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
                  this.onCancelDialog();
              },
          })
      );
  }

  async scrollLazyLoad(event) {
      const scrollTop = event.target.scrollTop;
      const scrollHeight = event.target.scrollHeight;
      const offsetHeight = event.target.offsetHeight;
      if (scrollTop + offsetHeight >= scrollHeight - 20 && !this.isEndChatList) {
        await this.loadnewchats()
        await new Promise((res) => setTimeout(res, 0));
      }
  }

  async loadnewchats(): Promise<void> {
    const day1 = new Date();
    day1.setDate(1);
    let month = new Date(day1.getFullYear(), day1.getMonth() - this.monthReducer, 1).getMonth();
    let startDate = new Date(day1.getFullYear(), day1.getMonth() - this.monthReducer, 1).getTime();
    const year = new Date(day1.getFullYear(), day1.getMonth() - this.monthReducer, 1).getFullYear();
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ];
        this.allChats.push({
            chats: [],
            showChats: true,
            period: monthNames[month],
            startDate: startDate,
            endDate: this.allChats?.at(-1)?.startDate,
            name: `${monthNames[month]} ${year}`,
        });
    this.syncAllChatsToService();
    this.chatPeriod = monthNames[month];
    this.monthReducer += 1;
    await this.getChatsList();
}

  isDocumentChat(chat: IChat | undefined): boolean {
    if (!chat) return false;

    const documentChatTypes: ChatType[] = [
      ChatType.UnstructuredDocument,
      ChatType.StructuredDocument,
      ChatType.StructuredUnstructuredDocs,
      ChatType.ESGStructuredDocs,
      ChatType.ESGStructuredUnstructuredDocs,
    ];

    const hasDocuments = (chat.chatDocument?.length ?? 0) > 0;
    const hasTables = (chat.chatTables?.length ?? 0) > 0;
    const isDocumentType = !!chat.chatType && documentChatTypes.includes(chat.chatType);

    return hasDocuments || hasTables || isDocumentType;
  }

  updateChat(event: IChat, type: string, interaction?:IChatInteraction) {
      // this.selectedChat=event.chatId
      if(event?.chatConfig){
        this.chatServices.chatConfig = event.chatConfig
      }else{
        this.chatServices.chatConfig = {}
      }
      this.activeChat = event;
      this.updatedChatName=this.activeChat?.chatName
      this.chatServices.emitChatSelected({
          type: type === 'updatechat' ? 'updateChat' : 'newsession',
          activeChat: this.activeChat,
          chatId: this.activeChat?.chatId,
          period: this.currentChatPeriod,
          interaction: interaction
      });
  }
  getUpdatedName(event){
      const inputElement = event.target as HTMLInputElement;
      this.updatedChatName = inputElement.value;
      if(  event.key === 'Enter'){
          this.editChatName()
      }
  }

  editChatName(){
          this.chatServices.editChatDetails(this.activeChat.chatId,{chatName : this.updatedChatName}, true).subscribe({
              next:(res)=>{
                  this.updateoldchatLIst()
              }
          })

  }

  private updateChatInList(updatedChat: IChat): void {
    this.allChats?.forEach(group => {
      const idx = group?.chats?.findIndex(chat => chat.chatId === updatedChat.chatId);
      if (idx !== -1) {
        group.chats[idx] = { ...group.chats[idx], ...updatedChat };
      }
    });
  }

  checkChatUpdate(event:IChat){
    if(event?.chatId){
      this.chatServices.updateChatTypeStatus(event.chatType ? event.chatType : ChatType.Normal)
    }
    if(!event){
      return;
    }

    // Optimistically highlight the selection
    this.activeChat = event;

    if(!event.chatId){
      this.updateChat(event,'updatechat')
      return;
    }

    this.getChatDetailsSub.unsubscribe();
    this.getChatDetailsSub = this.chatServices.getchatById(event.chatId).subscribe({
      next: (freshChat: IChat) => {
        this.updateChatInList(freshChat);
        this.updateChat(freshChat,'updatechat');
      },
      error: () => {
        // Fall back to existing data if the refresh fails
        this.updateChat(event,'updatechat');
      }
    });
  }

  openCustomInstructionsDialog() {
    this.displayCustomInstructions = true;
  }

  submitInstructions(event:any) {
    this.displayCustomInstructions = false;
  }

  closeDialog(value: boolean) {
    this.displayCustomInstructions = false;
  }

  updatesplitButtonItems(event:any){
    this.selectedsplitButtonItems = cloneDeep(this.splitButtonItems).filter(item => item.label !== event.label);
    this.selectedChatType = event.label
  }

  selectUpdateChatType(chatType?:string){
    switch(this.selectedChatType){
      case 'QIQ Chat':
        this.updateNewChat({item:{label:'QIQ Chat'}})
        break;
      case 'ESG':
        this.updateESGChat({item:{label:'ESG'}})
        break;
      case 'WFDO':
        this.updateQECChat({item:{label:'WFDO'}})
        break;
      case 'DS Playground':
        this.updateCodeInterpreterChat({item:{label:'DS Playground'}})
        break;
      case 'Open Web Chat':
        this.updateagenticWorkflow({item:{label:'Open Web Chat'}})
        break;
      case 'Bookmarks':
        this.updatebookmarkChatType({item:{label:'Bookmarks'}})
        break;
    }
  }

  updateChatTypeFromChatMain(chatType:{label:string,type:ChatType}){
    this.updatesplitButtonItems({item:{label:'QIQ Chat'}})
    this.selectedChatType=chatType.label
    this.updateChatType(chatType.type);
    this.newChat();
  }

  toggledropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleUsageStats(showStats:boolean){
    this.showUsageStats=showStats
  }

  fetchSearchResults(): void {
    this.searchLoading = true;
    const chatType = this.chatServices.getChatType();
    const payload: any = {
      pageSize: 10,
      searchText: this.searchText,
    };

    if ([ChatType.QEC, ChatType.ESG, ChatType.quilt].includes(chatType)) {
      payload.chatType = chatType;
    }

    if (this.searchText.trim() === '') {
      this.searchResults = [];
      this.searchLoading = false;
      return;
    }

    this.chatServices.searchChats(payload).subscribe({
      next: (response) => {
        this.searchResults = response;
        this.searchLoading = false;
        if (response.length > 0) {
          const lastInteraction = response?.at(-1)?.interaction;
          this.lastUpdatedAt = lastInteraction.updatedAt;
          this.lastChatId = lastInteraction.chatId;
          this.isEndSearchResults = response.length < 10;
        } else {
          this.isEndSearchResults = true;
        }
      },
      error: () => {
        this.searchLoading = false;
      },
    });
  }

  onScroll(event: Event): void {
    this.scrollSubject.next(event);
  }

  private handleScroll(event: Event): void {
    const target = event.target as HTMLElement;

    if (
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20 &&
      !this.isEndSearchResults &&
      !this.isFetchingResults
    ) {
      const payload: any = {
        pageSize: 10,
        searchText: this.searchText,
      };

      if (this.lastUpdatedAt && this.lastChatId) {
        payload.before = this.lastUpdatedAt;
        payload.excludeChatId = this.lastChatId;
      }

      const chatType = this.chatServices.getActiveChat()?.chatType;
      if (chatType && [ChatType.QEC, ChatType.ESG, ChatType.quilt].includes(chatType)) {
        payload.chatType = chatType;
      }

      this.isFetchingResults = true;
      const currentScrollTop = target.scrollTop;

      this.chatServices.searchChats(payload).subscribe({
        next: (response) => {
          if (response.length > 0 && response != "No Results") {
            const lastInteraction = response?.at(-1).interaction;
            this.lastUpdatedAt = lastInteraction.updatedAt;
            this.lastChatId = lastInteraction.chatId;
            this.isEndSearchResults = response.length < 10;

            // Append new results to the existing ones
            this.searchResults = [...this.searchResults, ...response];
          } else {
            this.isEndSearchResults = true;
          }
          this.isFetchingResults = false;

          // Restore scroll position
          setTimeout(() => {
            target.scrollTop = currentScrollTop;
          }, 0);
        },
        error: () => {
          this.isFetchingResults = false;
        },
      });
    }
  }

  onSearchChatClick(chat: any): void {
    this.chatServices.getchatById(chat.interaction.chatId).subscribe({
        next: (response) => {
            if (response?.chatState === ChatState.Archived) {
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'This chat is deleted.',
              });
              return;
            }
            this.currentChatPeriod = 'Today';
            this.checkChatUpdate(response);
            this.searchDialogVisible = false;
        },
        error: () => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Unable to open this chat. Please try again.',
          });
        }
    });
  }

  

calculateContentHeight(): number {
    let totalHeight = 0;
    let tempAllChats = this.allChats.filter(chat => chat.chats.length > 0);
    tempAllChats.forEach((chat, index) => {
            const container = document.querySelectorAll('.chatsListContainer')[index];
            if (container) {
                totalHeight += container.clientHeight;
            }
        // } else {
        //     console.log(`Skipping collapsed group ${chat.period}`);
        // }
    });

    return totalHeight;
}


/**
   * Finds the period a chat belongs to based on its updatedAt timestamp
   * and returns the startDate & endDate for that period
   * @param chat The chat to find the period for
   * @returns Object with startDate, endDate, period, and isBookmarks, or null if not found
   */
  findChatPeriod(chat: IChat): { startDate: number; endDate: number; period: string; isBookmarks: boolean } | null {
    if (!chat?.updatedAt) {
      return null;
    }

    const chatUpdatedAt = new Date(chat.updatedAt).getTime();

    for (const periodItem of this.allChats) {
      if (periodItem.isBookmarks) {
        continue;
      }
      if (chatUpdatedAt >= periodItem.startDate && chatUpdatedAt < periodItem.endDate) {
        return {
          startDate: periodItem.startDate,
          endDate: periodItem.endDate,
          period: periodItem.period,
          isBookmarks: periodItem.isBookmarks || false
        };
      }
    }

    return null;
  }

  /**
   * Refreshes the chat list for the period that contains the given chat
   * @param chat The chat whose period should be refreshed
   */
  refreshChatPeriod(chat: IChat): void {
    const periodInfo = this.findChatPeriod(chat);
    if (!periodInfo) {
      return;
    }

    this.getAllChatsSub.add(
      this.chatServices
        .getAllChats(periodInfo.startDate, periodInfo.endDate, periodInfo.isBookmarks)
        .subscribe({
          next: (response: IChat[]) => {
            const chatsList: IChat[] = response;
            this.allChats.forEach((e) => {
              if (e.period === periodInfo.period) {
                e.chats = chatsList;
                e.showChats = true;
              }
            });
            this.syncAllChatsToService();
          },
          error: (error) => {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.error.message,
            });
          },
        })
    );
  }

async checkAndLoadOlderChats(): Promise<void> {
  setTimeout(async () => {
    const sidebarElement = document.querySelector('.sidebar');
    const sidebarHeight = sidebarElement?.clientHeight || 0;
    let contentHeight = this.calculateContentHeight();

    let whitespaceHeight = sidebarHeight - contentHeight;

    let retries = 0;
    const maxRetries = 6;
    while (whitespaceHeight > 0 && retries < maxRetries) {
      const lastChatGroup = this.allChats?.at(-1);
      if (lastChatGroup?.startDate && this.createdAt && lastChatGroup.startDate < this.createdAt) {
        break;
      }

      this.isLoadingOlderChats = true;
      await this.loadnewchats();
      contentHeight = this.calculateContentHeight(); // Recalculate content height
      whitespaceHeight = sidebarHeight - contentHeight; // Recalculate whitespace height
      retries++;
    }
    this.isLoadingOlderChats = false;
  }, 100);
}


}
